// FundDiscoveryController
app.controller('FundDiscoveryController', ['$scope', 'WdHttpService', 'sessionService', 'config',
    function ($scope, WdHttpService, sessionService, config) {

        // Init 
        $scope.init = async function () {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            $scope.fund = {};
            $scope.showSuggestedFunds = false;
            $(function () {
                $('#funds').addClass('active');
                $('#discover-funds').addClass('active');
            });
            if (sessionService.isLoggedIn()) {
                $scope.getFundsBasedOnRiskProfile();
            }
            await $scope.getFunds();
            $scope.hidePageLoader();
        }

        $scope.resultFound = true;
        $scope.noResultFound = false;

        var fundsLength = '';

        $scope.limit = 10;
        $scope.dataLoadMore = true;

        $scope.fundData = [];
        $scope.fundDataFilter = [];

        $scope.compareFundData = [];

        $scope.compareFundDataLength = $scope.compareFundData.length;

        $scope.productType = [];

        $scope.getFundsBasedOnRiskProfile = async function () {
            $scope.riskLevel = await WdHttpService._get_user_risk_profile(false);
            if ($scope.riskLevel == undefined) {
                $scope.riskLevel = '';
                if (!sessionService.isQcLoggedIn()) {
                    try {
                        await loginToQc($scope, WdHttpService);
                    } catch (error) {
                        console.log(error);
                        return;
                    }
                }
                var data = {
                    client_code: sessionService.get('cognito_username'),
                    amc: $scope.distributorUsername
                };

                WdHttpService._qc_risk_profile_details(data)
                    .then(async response => {
                        if (response.score > -1) {
                            if (response.score > 1) {
                                $scope.riskLevel += 'MEDIUM,';
                                if (response.score < 4)
                                    await WdHttpService._update_cognito_profile('custom:risk', 'MEDIUM');
                            } else {
                                await WdHttpService._update_cognito_profile('custom:risk', 'LOW');
                            }

                            if (response.score > 3) {
                                $scope.riskLevel += 'HIGH,';
                                await WdHttpService._update_cognito_profile('custom:risk', 'HIGH');
                            }
                            $scope.riskLevel += 'LOW';

                        } else {
                            $scope.showSuggestedFunds = false;
                        }
                    }).catch(error => {
                        console.log(error);
                        $scope.showSuggestedFunds = false;
                    });
            } else {
                if ($scope.riskLevel == "HIGH")
                    $scope.riskLevel = 'HIGH, MEDIUM, LOW';
                else if ($scope.riskLevel == 'MEDIUM')
                    $scope.riskLevel = 'MEDIUM, LOW';
                else
                    $scope.riskLevel = 'LOW';
            }

            var qData = {
                size: 3,
                q: $scope.filter('risk', $scope.riskLevel),
                f: "web_admin:" + $scope.webadminName,
                sort: 'return:desc'
            }
            WdHttpService._get_funds(qData)
                .then(response => {
                    $scope.suggestedFunds = response.data.Items
                    $scope.showSuggestedFunds = true;
                }).catch(error => {
                    console.log(error);
                });

        }

        $scope.getFunds = async function () {
            var data = {
                f: "web_admin:" + $scope.webadminName,
                size: 100
            }
            await WdHttpService._get_funds(data)
                .then(function (response) {
                    $scope.loadingFunds = true;
                    fundsLength = response.data.Items.length;
                    if (fundsLength == 0) {
                        $scope.resultFound = false;
                        $scope.noResultFound = true;
                        $scope.dataLoadMore = false;
                        $scope.loadingFunds = false;
                    } else {
                        $scope.dataLoadMore = true;
                        $scope.noResultFound = false;
                        $scope.loadingFunds = false;
                        $scope.resultFound = true;
                        $scope.fundData = response.data.Items;

                        $scope.fundData.forEach(fundDetail => {
                            fundDetail.fundIcon = fundDetail.fundIcon ? fundDetail.fundIcon : 'assets/img/wealthbasket-logo.jpg';
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.decideRiskProfileSection = function () {
            if ('SHOW_RISK_PROFILE_SECTION' in config)
                return !config.SHOW_RISK_PROFILE_SECTION;
            return false;
        }

        $scope.selectFunds = function (view) {

            if ($('#select_fund_type_' + view.fundName).is(':checked')) {
                var selectFundToComp = view.fundName;

                var data = {
                    q: "fundName:" + selectFundToComp,
                    f: "web_admin:" + $scope.webadminName
                };
                WdHttpService._get_funds(data).then(function (response) {
                    var CompFunds = [];
                    if (response.data.Items.length > 1) {
                        response.data.Items.forEach(fund => {
                            if (fund.fundName == view.fundName)
                                CompFunds.push(fund);
                        });
                    } else
                        CompFunds.push(response.data.Items[0]);

                    angular.forEach(CompFunds, function (value, key) {
                        $scope.compareFundData.push(value);
                    });
                    $scope.compareFundDataLength = $scope.compareFundData.length;
                    if ($scope.compareFundDataLength == 2) {
                        $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", true);
                        $('.dw-listed-pdct input[type="checkbox"]:checked ').attr("disabled", false);
                    } else {
                        $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", false);
                    }

                    var compareData = $scope.compareFundData;
                    $scope.f1 = compareData[0].fundName;
                    $scope.f2 = compareData[1].fundName;
                });

            } else {
                var dataTittleOne = $(".dw-related-data-top").data("title");
                var dataTittleTwo = $(".dw-related-data").data("title");
                if (dataTittleOne == dataTittleTwo) {
                    var index = $scope.compareFundData.indexOf(view);
                    $scope.compareFundData.splice(index, 1);
                    $scope.compareFundDataLength = $scope.compareFundData.length;
                    if ($scope.compareFundDataLength == 2) {
                        $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", true);
                        $('.dw-listed-pdct input[type="checkbox"]:checked ').attr("disabled", false);
                    } else {
                        $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", false);
                    }
                }
            }
        };


        $scope.remove = function (compFund) {
            var name = compFund.fundName;
            angular.forEach($scope.fundData, function (item, key) {
                if (item.fundName === name) {
                    item.selected = false;
                }
            });
            var index = $scope.compareFundData.indexOf(compFund);
            $scope.compareFundData.splice(index, 1);
            $scope.compareFundDataLength = $scope.compareFundData.length;
            if ($scope.compareFundDataLength == 2) {
                $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", true);
                $('.dw-listed-pdct input[type="checkbox"]:checked ').attr("disabled", false);
            } else {
                $('.dw-listed-pdct input[type="checkbox"]').attr("disabled", false);
            }

        };


        $scope.searchFunds = function () {

            var data = {
                q: $scope.search,
                f: "web_admin:" + $scope.webadminName
            };
            var responseFunds = WdHttpService._get_funds(data).then(function (response, status) {
                fundsLength = response.data.Items.length;

                if (fundsLength == 0) {
                    $scope.resultFound = false;
                    $scope.noResultFound = true;
                    $scope.dataLoadMore = false;
                } else {
                    $scope.dataLoadMore = true;
                    $scope.noResultFound = false;
                    $scope.resultFound = true;
                    $scope.fundData = response.data.Items;

                }
            });
        };

        var filterArray = {};

        $scope.filter = function (key, value) {
            filterArray = {};
            if (filterArray[key] == undefined)
                filterArray[key] = value;
            else
                filterArray[key] = filterArray[key] + ',' + value;
            return constructRequest();
        }

        function constructRequest() {
            var requestString = '';
            var allKeys = Object.keys(filterArray);
            allKeys.forEach(key => {
                var filterValues = filterArray[key].split(',');
                var condition = '';
                filterValues.forEach(value => {
                    condition += buildCondition(key, value, condition)
                });
                condition += '';
                if (condition !== '()') {
                    if (requestString === '')
                        requestString = condition;
                    else
                        requestString += 'AND' + condition;
                    condition = '';
                }
            });

            return requestString;
        }

        $scope.filterFunds = function () {
            var prdType = $scope.fund.product_type;
            var prdsortby = $scope.fund.sort_by;

            var data = {
                q: constructRequest(),
                f: "web_admin:" + $scope.webadminName
            };

            var responseFunds = WdHttpService._get_funds(data).then(function (response, status) {
                var fundsLength = response.data.Items.length;
                $scope.showAdvancedFilter = false;

                if (fundsLength == 0) {
                    $scope.resultFound = false;
                    $scope.noResultFound = true;
                    $scope.dataLoadMore = false;
                } else {
                    $scope.dataLoadMore = true;
                    $scope.noResultFound = false;
                    $scope.resultFound = true;
                    $scope.fundData = response.data.Items;
                }
            });
        }

        $scope.loadMore = function () {
            $scope.limit = $scope.limit + 6;
            if ($scope.limit >= fundsLength) {
                $scope.dataLoadMore = false;
            }
        };

        $scope.analyseHoldings = async function () {
            if (sessionService.isLoggedIn()) {
                $scope.showPageLoader();
                if (!sessionService.isQcLoggedIn()) {
                    await WdHttpService._qc_login().then(response => {
                        $scope.$parent.isQcLoggedIn = true;
                    })
                }
                window.location = config.QC_ANALYZER_URL + "/upload-data?&qcAuth=" + btoa(sessionService.get("qcLogin").idToken) + "&wdAuth=" + btoa(sessionService.get("id")) + "&expiresIn=" + btoa(sessionService.get("qcExpiresIn"));
            } else {
                window.location = "/broker-login?action=holdingsAnalyse";
            }
        }

        $scope.isAnalyzerEnabled = function () {
            return config.ANALYZER_SWITCH;
        }

        async function loginToQc($scope, WdHttpService) {
            await WdHttpService._qc_login()
                .then(response => {
                    $scope.$parent.isQcLoggedIn = true;
                }).catch(error => {
                    console.log('Logging to QC failed');
                    console.error(error);
                });
        }

        function buildCondition(key, value, condition) {
            if (condition.indexOf(key) == -1)
                return key + ':' + value;
            else
                return '+' + key + ':' + value;
        }
    }
]);